import { useContext, useEffect, useState } from "react";
import { Box, Button, Container, FormControl, Grid, Stack, SvgIcon, TextField, Typography } from "@mui/material";
import { ReactComponent as Logo } from "../../assets/svg/logo.svg";
import { getToken, signUpUser } from "../../services/Authentication";
import SnackbarContext from "../../context/SnackbarContext";

export default function Login({ setCookies }) {
  const snackbar = useContext(SnackbarContext);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const [login, setLogin] = useState(true);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [passwordConfirmationError, setPasswordConfirmationError] = useState(false);

  useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        if (login) {
          handleLogin();
        } else {
          handleSignUp();
        };
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  });

  const handleLogin = () => {
    if (username === "") {setUsernameError(true)};
    if (password === "") {setPasswordError(true)};

    if (username !== "" && password !== "") {
      snackbar.createError("Invalid username and password combination.");
      // getToken(username, password).then(response => {
      //   if (response.token && response.id && response.accounts) {
      //     if (response.accounts.length === 0) {
      //       snackbar.createError("Your profile has not been associated with an account yet.");
      //     } else {
      //       setCookies(response.token, response.id);
      //     }
      //   } else {
      //     snackbar.createError("Invalid username and password combination.");
      //   }
      // });
    };
  };

  const handleSignUp = () => {
    if (firstName === "") {setFirstNameError(true)};
    if (lastName === "") {setLastNameError(true)};
    if (username === "") {setUsernameError(true)};
    if (password === "") {setPasswordError(true)};
    if (passwordConfirmation === "") {setPasswordConfirmationError(true)};

    if (username !== "" && password !== "" && passwordConfirmation !== "" && firstName !== "" && lastName !== "") {
      if (password === passwordConfirmation) {
        signUpUser(username, password, firstName, lastName).then(response => {
          if (response.ok) {
            snackbar.createSuccess("Thanks for signing up! A RevOptimal representative has been notified and will be in touch.");
          } else {
            snackbar.createError("Invalid username and password combination.");
          }
        });
      } else {
        setPasswordError(true);
        setPasswordConfirmationError(true);
        snackbar.createError("Passwords must match.")
      };
    };
  };

  const handleSwitchToSignUp = () => {
    if (login) {
      setLogin(false);
      setUsername("");
      setPassword("");
      setUsernameError(false);
      setPasswordError(false);
    };
  };

  const handleSwitchToLogin = () => {
    if (!login) {setLogin(true)};
    setUsername("");
    setPassword("");
    setPasswordConfirmation("");
    setFirstName("");
    setLastName("");
    setUsernameError(false);
    setPasswordError(false);
    setPasswordConfirmationError(false);
  };

  return (
    <Box>
      <Box sx={{position:"absolute", height:1/1, width:3/10, background:"#1E3056", zIndex:0}}>
      </Box>
      <Box sx={{position:"absolute", height:1/1, left:"30vw", width:7/10, background: "linear-gradient(127deg, #0FB4E5 0%, #743FE5 91%)", zIndex:0}}>
      </Box>
      <Container sx={{position:"absolute", zIndex:10, minWidth:"100vw"}}>
        <Box sx={{display:"flex", height:"100vh"}}>
          <Grid container spacing={6} sx={{mx:"12vw"}}>
            <Grid item xs={6} sx={{my:"auto"}}>
              <Box sx={{background:"#fdfdfd", padding:5, borderRadius:2}}>
                <SvgIcon sx={{width:"100%", fontSize:"6rem", paddingBottom:4}}>
                  <Logo color="#1E3056" />
                </SvgIcon>
                {login ? (
                  <Stack spacing={2}>
                    <TextField 
                      error={usernameError}
                      variant="outlined"
                      label="Email"
                      id="email"
                      onChange={(event) => {setUsername(event.target.value); setUsernameError(false)}}
                    />
                    <TextField 
                      error={passwordError}
                      variant="outlined"
                      label="Password"
                      type="password"
                      id="password"
                      onChange={(event) => {setPassword(event.target.value); setPasswordError(false)}}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleLogin}
                      onKeyDown={(event) => {console.log(event)}}
                    >
                      Login
                    </Button>
                    {/* <Box sx={{display:"flex"}}>
                      <Button
                        variant="text"
                        color="neutralInverted"
                        sx={{ width: 1/2, fontWeight: "bold", mx:"auto"}}
                        onClick={handleSwitchToSignUp}
                      >
                        New user? Sign up here!
                      </Button>
                    </Box> */}
                  </Stack>
                ) : (
                  <Stack spacing={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <FormControl>
                          <TextField 
                            error={firstNameError}
                            variant="outlined"
                            label="First Name"
                            id="firstName"
                            autoComplete="given-name"
                            onChange={(event) => {setFirstName(event.target.value); setFirstNameError(false)}}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl>
                          <TextField 
                            error={lastNameError}
                            variant="outlined"
                            label="Last Name"
                            id="lastName"
                            autoComplete="family-name"
                            onChange={(event) => {setLastName(event.target.value); setLastNameError(false)}}
                          />
                        </FormControl> 
                      </Grid>
                    </Grid>
                    <FormControl>
                      <TextField 
                        error={usernameError}
                        variant="outlined"
                        label="Email"
                        id="email"
                        autoComplete="off"
                        onChange={(event) => {setUsername(event.target.value); setUsernameError(false)}}
                      />
                    </FormControl>
                    <FormControl>
                      <TextField 
                        error={passwordError}
                        variant="outlined"
                        label="Password"
                        id="password"
                        type="password"
                        autoComplete="off"
                        onChange={(event) => {setPassword(event.target.value); setPasswordError(false)}}
                      />
                    </FormControl>
                    <FormControl>
                      <TextField 
                        error={passwordConfirmationError}
                        variant="outlined"
                        label="Confirm Password"
                        id="passwordConfirmation"
                        type="password"
                        autoComplete="off"
                        onChange={(event) => {setPasswordConfirmation(event.target.value); setPasswordConfirmationError(false)}}
                      />
                    </FormControl>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSignUp}
                      onKeyDown={(event) => {console.log(event)}}
                    >
                      Signup
                    </Button>
                    <Box sx={{display:"flex"}}>
                      <Button
                        variant="text"
                        color="neutralInverted"
                        sx={{ width: 3/4, fontWeight: "bold", mx:"auto"}}
                        onClick={handleSwitchToLogin}
                      >
                        Already have an account? Login here!
                      </Button>
                    </Box>
                  </Stack>
                )}
                
              </Box>
            </Grid>
            <Grid item xs={6} sx={{color:"white", my:"auto"}}>
              <Typography variant="h4" fontWeight={"bold"}>
                Let's Engage Your <br></br>
                Best Customers.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}